import type { ConfigType } from "@plone/registry";
import { nonContentRoutes } from './NonContentRoutes';
import {
  ArticleContainerView,
  MyShops,
  MyShopsPlug,
  OrderView,
  OrdersView,
  ShippingAgentSettings,
  ShippingAgentSettingsEdit,
  ShippingAgentsSettings,
  ShopView,
} from '../components';
import { RedirectToMyShops } from '../components';
import { widgetMapping } from './Widgets';
import reducers from '../reducers';
//import './theme/main.scss';

export default function install(config: ConfigType) {
  // Language settings
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['en', 'es', 'ca', 'eu', 'gl'];
  config.settings.defaultLanguage = "es";

  config.settings.additionalToolbarComponents = {
    ...config.settings.additionalToolbarComponents,
    myshopsMenu: {
      component: MyShopsPlug,
      wrapper: null,
    },
  };
  config.settings.nonContentRoutes = [
    ...config.settings.nonContentRoutes,
    ...nonContentRoutes,
  ];
  config.settings.appExtras = [
      ...config.settings.appExtras,
      {
        match: '',
        component: RedirectToMyShops,
      },
    ];
  config.views = {
    ...config.views,
    contentTypesViews: {
      ...config.views.contentTypesViews,
      'apanymantel.cart.shopping.Shop': ShopView,
      'apanymantel.cart.shopping.ArticleContainer': ArticleContainerView,
    },
    layoutViews: {
      ...config.views.layoutViews,
    },
  };
  config.widgets = {
    ...config.widgets,
    widget: {
      ...config.widgets.widget,
      ...widgetMapping.widget,
    },
    views: {
      ...config.widgets.views,
      widget: {
        ...config.widgets.views.widget,
        ...widgetMapping.views.widget,
      },
    },
  };
  config.addonReducers = {
    ...config.addonReducers,
    ...reducers,
  }
  config.addonRoutes = [
    ...config.addonRoutes,
    {
      path: '/myshops',
      exact: true,
      component: MyShops,
    },
    {
      path: '/order',
      component: OrderView,
    },
    {
      path: '/**/order',
      component: OrderView,
    },
    {
      path: '/orders',
      component: OrdersView,
    },
    {
      path: '/**/orders',
      component: OrdersView,
    },
    {
      path: '/**/shipping-agents-settings',
      component: ShippingAgentsSettings,
    },
    {
      path: '/**/shipping-agent-settings/:id/edit',
      component: ShippingAgentSettingsEdit,
    },
    {
      path: '/**/shipping-agent-settings/:id',
      component: ShippingAgentSettings,
    },
  ];



  return config;
}
